import { render, staticRenderFns } from "./memoir.vue?vue&type=template&id=5a7a11ad"
import script from "./memoir.vue?vue&type=script&lang=js"
export * from "./memoir.vue?vue&type=script&lang=js"
import style0 from "./memoir.vue?vue&type=style&index=0&id=5a7a11ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports